import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { DeleteContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { DeleteContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const deleteContacts = (request: DeleteContactsRequest, options?: CashRequestOptions) =>
  post<DeleteContactsRequest, DeleteContactsResponse>('/2.0/cash/delete-contacts', request, {
    ...options,
    rejectOnError: true,
  })
